import apiFetch from '@wordpress/api-fetch';

export async function fetchProducts( filters, signal ) {
	const params = buildQueryParams( filters );
	const path   = `/modern-woo/v1/products?${ params }`;

	try {
		const data = await apiFetch( { path, signal } );
		return data;
	} catch ( error ) {
		if ( error.name === 'AbortError' ) {
			return null;
		}
		throw error;
	}
}

export async function fetchCategories() {
	return apiFetch( { path: '/modern-woo/v1/categories' } );
}

export async function fetchPriceRange() {
	return apiFetch( { path: '/modern-woo/v1/price-range' } );
}

function buildQueryParams( filters ) {
	const params = new URLSearchParams();

	if ( filters.page )      params.set( 'page', filters.page );
	if ( filters.perPage )   params.set( 'per_page', filters.perPage );
	if ( filters.search )    params.set( 'search', filters.search );
	if ( filters.orderby )   params.set( 'orderby', filters.orderby );
	if ( filters.minPrice )  params.set( 'min_price', filters.minPrice );
	if ( filters.maxPrice )  params.set( 'max_price', filters.maxPrice );

	if ( filters.categories?.length ) {
		filters.categories.forEach( ( c ) => params.append( 'category[]', c ) );
	}

	if ( filters.tags?.length ) {
		filters.tags.forEach( ( t ) => params.append( 'tag[]', t ) );
	}

	if ( typeof filters.includeChildren !== 'undefined' ) {
		params.set( 'include_children', filters.includeChildren ? '1' : '0' );
	}

	return params.toString();
}
